"use client"
import type { SocialMedia } from '@/lib/social/types'
import { VideoPlayer } from '@/components/ui/video-player'

export function SocialVideo({ media, preview = false, compact = false }: { media: SocialMedia; preview?: boolean; compact?: boolean }) {
  return <VideoPlayer src={media.url} poster={media.posterUrl} title={media.alt} lazy pauseWhenHidden
    className={compact ? undefined : preview ? 'max-h-[600px]' : 'max-h-[560px]'}
    style={{ ...(media.width > 0 && media.height > 0 ? { aspectRatio: `${media.width}/${media.height}` } : {}), ...(compact ? { height: 'clamp(280px, 45vw, 320px)' } : {}) }} />
}
